var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"legal-text",on:{"click":_vm.openOverlay}},[_vm._v(" "+_vm._s(_vm.$t("age_check.legal_conditions"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }